module.exports = __webpack_public_path__ + "media/base/vendor_truck_medium-4deb3b63.svg";